import React, { useEffect, useState } from "react";
import axios from "axios";
import params from "../params";
import Dim from "../components/Dim";
import Requests from "../utils/requests";

function Player(props) {
    return (
        <li className="leaders-player" onClick={() => props.onClick(props.item, props.list)}>
            <p>#{props.index} {props.username}</p>
            <p>{props.points}pts</p>
        </li>
    );
}

class ModalWindow extends React.Component {
    constructor(props) {
        super(props);
        this.state = { active: false, item: null, records: [], list: '' };
        ModalWindow.modal = this;
    }
    
    render() {
        const { active, item, records, list } = this.state;
    
        return (
            <div className={`level-modal-window ${active ? 'active' : ''}`}>
                <h3>{item ? item.userName : ''}</h3>
                <p className="victors">
                    {
                        records.length > 0 ? records.map((e, index) => {
                            return <a href={e.url} target="_blank" key={index}>{index + 1}. {e.levelName}</a>
                        }) : null
                    }
                </p>
            </div>
        );
    }

    static getWindow(item, list) {
        ModalWindow.setData(item, list);
        Dim.openDim();
    }

    static closeWindow() {
        const modal = ModalWindow.modal;
        if(modal) modal.setState({ active: false });
    }

    static async setData(item, list) {
        const modal = ModalWindow.modal;
        if(!modal) return;

        try {
            let r;
            if(params.server) {
                r = await axios.post(params.apiUrl + '/demonlist/getUserRecords.php', {
                    userName: item.userName,
                    list: list
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                });
            } else {
                r = await Requests.getUserRecords(item.userName, list);
            }

            const lines = r.data.split('\n');
            const records = [];

            for(let i = 0; i < lines.length; i++) {
                if(!lines[i]) continue;

                const params = lines[i].split(';');
                // if(params[1] != item.id) continue;

                records.push({ levelName: params[4], url: params[3] });
            }

            modal.setState({ active: true, item: item, records: records });
        } catch(e) {
            throw new Error(e.message);
        }
    }
}

export default function Leaders() {
    const [activeDropDown, setActiveDropDown] = useState('_demons');
    const [users, setUsers] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    useEffect(() => {
        const req = async () => {
            try {
                let r;
                if(params.server) {
                    r = await axios.post(params.apiUrl + '/demonlist/getLeaders.php', {
                        list: activeDropDown,
                    }, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    });
                } else {
                    r = await Requests.getLeaders(activeDropDown);
                }
                
                const players = new Map();
                const lines = r.data.split('\n');

                for(let i = 0; i < lines.length; i++) {
                    if(!lines[i]) continue;

                    const params = lines[i].split(';');
                    const userName = params[0];
                    const points = parseInt(params[4], 10);

                    if (!players.has(userName)) players.set(userName, { userName, id: params[1], url: params[3], points: 0 });
                    players.get(userName).points += points;
                }

                const sortedEntries = Array.from(players.entries()).sort((a, b) => b[1].points - a[1].points);
                const users = sortedEntries.map((entry) => entry[1]);
                setUsers(users);
            } catch(e) {
                throw new Error(e.message);
            }
        }

        req();
    }, [activeDropDown]);

    const handleDropDownClick = (name) => {
        if (name === activeDropDown) {
            setIsDropdownOpen(!isDropdownOpen);
        } else {
            setActiveDropDown(name);
            setIsDropdownOpen(false);
        }
    }

    const handleUserClick = (item, list) => ModalWindow.getWindow(item, list);
    
    return (
        <main>
            <ModalWindow />
            <Dim window={ModalWindow} />
            <div className="leaders-wrapper">
                <div className="container">
                    <div className="leaders-body">
                        <div className="leaders-top">
                            <div className="dropdown-leaders-menu">
                                <button type="button" onClick={() => handleDropDownClick('_demons')} className={isDropdownOpen || activeDropDown === '_demons' ? 'active' : ''}>Демоны</button>
                                <button type="button" onClick={() => handleDropDownClick('_challenges')} className={isDropdownOpen || activeDropDown === '_challenges' ? 'active' : ''}>Челенджи</button>
                                <button type="button" onClick={() => handleDropDownClick('_platformers')} className={isDropdownOpen || activeDropDown === '_platformers' ? 'active' : ''}>Платформеры</button>
                            </div>
                            <p className="leaders-top-words">Топ игроков</p>
                        </div>
                        <ul className="leaders-players">
                            {
                                users.map((e, index) => {
                                    return <Player key={index} index={index + 1} username={e.userName} points={e.points} item={e} list={activeDropDown} onClick={handleUserClick} />
                                })
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </main>
    );
}